<script setup lang="ts">
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { RouterLink, useRouter } from 'vue-router'

type SidebarItem = {
  title: string
  url: string
}

const sidebarItems: SidebarItem[] = [
  {
    title: 'Tableau de bord',
    url: '/',
  },
  {
    title: "KPI chiffres d'affaires",
    url: '/kpi-chiffres-affaires',
  },
  {
    title: 'Clients',
    url: '/clients',
  },
//   {
//     title: 'Performance financière',
//     url: '/performances-financiere',
//   },
  {
    title: 'Suivi des commandes',
    url: '/suivi-des-commandes',
  },
  {
    title: 'Activité commercial',
    url: '/activite-commercial',
  },
  {
    title: 'Répartitions des formations',
    url: '/repartition-des-formations',
  },
]

const router = useRouter()
</script>

<template>
  <Sidebar>
    <SidebarHeader class="mx-auto">
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton class="text-2xl" asChild>
            <RouterLink to="/" class="py-10"> Nevea Dashboard</RouterLink>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
    <SidebarSeparator />
    <SidebarContent>
      <SidebarGroup>
        <SidebarGroupContent>
          <SidebarMenu>
            <SidebarMenuItem v-for="sidebarItem in sidebarItems" :key="sidebarItem.title">
              <RouterLink :to="sidebarItem.url">
                <SidebarMenuButton
                  asChild
                  size="lg"
                  :isActive="router.currentRoute.value.fullPath == sidebarItem.url"
                >
                  <span>{{ sidebarItem.title }}</span>
                </SidebarMenuButton>
              </RouterLink>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarContent>
  </Sidebar>
</template>
